var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme, TRANSITION } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLang } from '../hooks/use-lang';
import { EntityValuePill } from '../entities/entity-value-pill';
import { OnboardingButton } from './onboarding-button';
import { OnboardingButtons } from './onboarding-buttons';
import { useOnboarding } from '../context/onboarding-context';
var cls = classNames('onboarding-selection-step');
export var OnboardingSelectionStepDefaultProps = {
  items: [],
  entityKey: 'TrendExpertise',
  selectedItems: [],
  title: "Which best describes you?",
  onSelect: function () {},
  goToNextStep: function () {},
  goToPreviousStep: function () {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    max-width: 600px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    max-width: 600px;\n  "])), theme.UNIT(9))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: ", ";\n  "], ["\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: pointer;\n    user-select:  none;\n    border-color: ", ";\n    &:hover {\n      background-color: ", ";\n      ", "\n    }\n\n    &.selected {\n      color: ", ";\n      ", "\n      ", "\n      background-color: ", ";\n    }\n  "], ["\n    cursor: pointer;\n    user-select:  none;\n    border-color: ", ";\n    &:hover {\n      background-color: ", ";\n      ", "\n    }\n\n    &.selected {\n      color: ", ";\n      ", "\n      ", "\n      background-color: ", ";\n    }\n  "])), theme.COLOR('line-subtle'), theme.COLOR('just-visible'), TRANSITION('background-color'), theme.COLOR('light'), theme.FILL('light'), TRANSITION('background-color', 'color'), function (_a) {
    var isSelected = _a.isSelected,
      activeColor = _a.activeColor;
    return isSelected && activeColor ? activeColor : theme.COLOR('strong');
  })
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContinueStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    &:hover {\n      filter: brightness(1.05);\n      ", "\n    }\n  "], ["\n    &:hover {\n      filter: brightness(1.05);\n      ", "\n    }\n  "])), TRANSITION('filter'))
});
var PreviousButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingSelectionStep',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled(EntityValuePill)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Buttons: styled(OnboardingButtons)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  ContinueButton: styled(OnboardingButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContinueStyles),
  PreviousButton: styled(OnboardingButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PreviousButtonStyles)
};
export var OnboardingSelectionStep = function (props) {
  var componentProps = useComponentProps(My.NAME, OnboardingSelectionStepDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    _a = componentProps.items,
    items = _a === void 0 ? [] : _a,
    expertiseLevel = componentProps.expertiseLevel,
    entityKey = componentProps.entityKey;
  var t = useLang();
  var _b = useOnboarding(),
    goToPreviousStep = _b.goToPreviousStep,
    goToNextStep = _b.goToNextStep,
    onboardingSteps = _b.onboardingSteps,
    onboardingState = _b.onboardingState,
    currentStep = _b.currentStep,
    handleItemSelection = _b.handleItemSelection;
  var hasPreviousStep = currentStep > 0;
  var hasNextStep = currentStep < onboardingSteps.length - 1;
  var getSelectedItems = function () {
    if (expertiseLevel && entityKey) {
      var group = onboardingState.junctionSelections[entityKey] || [];
      var levelEntry = group.find(function (entry) {
        return entry.levelOfExpertise.id === expertiseLevel.id;
      });
      return levelEntry ? levelEntry.items : [];
    } else if (entityKey) {
      return onboardingState.simpleSelections[entityKey] || [];
    }
    return [];
  };
  var selectedItems = getSelectedItems();
  // Call the single context handler
  var onSelectHandler = function (selection) {
    if (!entityKey) {
      console.warn("OnboardingSelectionStep: entityKey prop is missing.");
      return;
    }
    handleItemSelection(entityKey, selection, expertiseLevel);
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Items, null, items.map(function (entity, index) {
    var _a;
    var isSelected = selectedItems.some(function (e) {
      return e.id === entity.id;
    });
    return React.createElement(My.Item, {
      key: entity.id || index,
      className: isSelected ? 'selected' : '',
      onClick: function () {
        return onSelectHandler(entity);
      },
      showLabel: false,
      entity: entity,
      isSelected: isSelected,
      activeColor: (_a = entity === null || entity === void 0 ? void 0 : entity.color) === null || _a === void 0 ? void 0 : _a.value,
      variant: "small"
    });
  })), React.createElement(My.Buttons, null, hasNextStep && React.createElement(My.ContinueButton, {
    onClick: goToNextStep
  }, t('Continue')), hasPreviousStep && React.createElement(My.PreviousButton, {
    colors: {
      background: 'transparent',
      text: 'strong',
      hover: {
        background: 'very-subtle'
      }
    },
    onClick: goToPreviousStep
  }, t('Back'))), children);
};
OnboardingSelectionStep.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;